module.exports = __webpack_public_path__ + "static/call_me_emoji-aaaa542df080daadb7408a68f0e65ac2.svg";